<!--
  Layout modal popup
  레이아웃이 필요한 팝업

  @since 2018-03-06
  @author kdydesign.kim
-->

<template>
  <q-modal v-model="isOpen"
           ref="layoutModalPopUp"
           @hide="onHide"
           @show="onShow"
           :content-css="contentCss"
           :positionClasses="'flex-center popup-scroll'"
           :draggable="true"
           :no-esc-dismiss="true"
           :no-backdrop-dismiss="true"
           :no-route-dismiss="noRouteDismiss"
           class="bs bs-q-modal bs-q-modal-default">
    <q-modal-layout>
      <!--header-->
      <q-toolbar slot="header">
        <q-icon v-if="iconClass !== ''" :class="iconClass"></q-icon>
        <q-toolbar-title>{{titleName}}</q-toolbar-title>
        <q-btn flat
               :auth-force="true"
               round
               dense
               @click="minimize">
          <q-icon :class="`q-icon popup-icons ${ minimized ? 'icon-pop-title-max' : 'icon-pop-title-min' }`"></q-icon>
        </q-btn>
        <q-btn flat
               :auth-force="true"
               :disable="closeDisable"
               round
               dense
               @click="onClose()">
          <q-icon name="close"></q-icon>
        </q-btn>
      </q-toolbar>

      <!--footer-->
      <q-toolbar slot="footer">
        <div class="contents-row">
          <div class="footer-option-group">
            <div v-if="isContinued"
                 class="footer-option-field-xs">
              <q-checkbox v-model="continuedChecked"
                          :ha-force="haForce"
                          class="bs bs-q-checkbox bs-q-checkbox-default">
              </q-checkbox>

              <span class="btn-auto-insert"></span>

              <tool-tip position="bottom"
                        :message="$t('cmn.continueStr')"></tool-tip>
            </div>
           <div v-if="isSynced"
                class="footer-option-field-xs">
              <q-checkbox v-model="syncedChecked"
                :ha-force="haForce"
                style="margin-right: 8px"
                class="bs bs-q-checkbox bs-q-checkbox-default"
                :label="$t('an.logAnalysisFiltersPopup_btn_syncStaticFilter_label')"
                :auth-force="true">
              </q-checkbox>
            </div>

            <q-btn v-for="btn in footerBtnList"
                   :auth-force="getAuthForce(btn.type)"
                   :ha-force="haForce"
                   :key="btn.type"
                   :label="btn.text"
                   :color="btn.color"
                   :disable="btn.disable || false"
                   :class="classStyle(btn.type)"
                   :outline="outlineStyle(btn.type)"
                   @click="onFooterEvent(btn.type)"></q-btn>
          </div>
        </div>
      </q-toolbar>

      <div :class="paddingClass">
        <!--Contents Body-->
        <slot></slot>
      </div>
    </q-modal-layout>
  </q-modal>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapState, mapMutations, mapActions, mapGetters } = createNamespacedHelpers('common/saveRollback')

  export default {
    name: 'LayoutModalPopup',
    props: {
      titleName: {
        type: String,
        default: 'unknow name'
      },
      paddingClass: {
        type: String,
        default: 'layout-padding'
      },
      contentCss: {
        type: Object,
        default: () => {
          return {
            width: '800px',
            height: '600px'
          }
        }
      },
      footerBtn: {
        type: Array,
        default: () => ['confirm', 'cancel', 'continue', 'close', 'search', 'reset', 'upload', 'remove', 'reject', 'applyConfirm', 'synced']
      },
      confirmEvt: {
        type: Function,
        default: _.noop()
      },
      uploadEvt: {
        type: Function,
        default: _.noop()
      },
      cancelEvt: {
        type: Function,
        default: _.noop()
      },
      continueEvt: {
        type: Function,
        default: _.noop()
      },
      syncEvt: {
        type: Function,
        default: _.noop()
      },
      continueApplyEvt: {
        type: Function,
        default: _.noop()
      },
      searchEvt: {
        type: Function,
        default: _.noop()
      },
      resetEvt: {
        type: Function,
        default: _.noop()
      },
      resetAuthForce: {
        type: Boolean,
        default: false
      },
      applyEvt: {
        type: Function,
        default: _.noop()
      },
      removeEvt: {
        type: Function,
        default: _.noop()
      },
      authForce: {
        type: Boolean,
        default: false
      },
      haForce: {
        type: Boolean,
        default: false
      },
      noRouteDismiss: {
        type: Boolean,
        default: false
      },
      closeDisable: {
        type: Boolean,
        default: false
      },
      noEscDismiss: {
        type: Boolean,
        default: false
      },
      iconClass: {
        type: String,
        default: ''
      },
      // TAMS
      disableSaveRollback: {
        type: Boolean,
        default: false
      },
      ignoreCheckInState: {
        type: Boolean,
        default: false
      },
      rejectEvt: {
        type: Function,
        default: _.noop()
      },
      applyConfirmEvt: {
        type: Function,
        default: _.noop()
      },
      // TAMS, 연속 입력 방지 (수동)
      // 가능한 $loader를 통한 화면 클릭 제어 방식 권장함. (현재 사용되는 곳 없음)
      footerBtnDisable: {
        type: Boolean,
        default: false
      },
      hideAfterCancel: {
        type: Boolean,
        default: true
      },
      synced: {
        type: Boolean,
        default: true
      },
      isSynced: {
        type: Boolean,
        default: false
      }
      // enableProcessingSavePoint: {
      //   type: Boolean,
      //   default: false
      // }
    },
    data () {
      return {
        isOpen: false,
        isContinued: false,
        // isSynced: false,
        continuedChecked: true,
        syncedChecked: true,
        minimized: false,
        // TAMS
        clickEvtType: void 0,
        ignoreRollback: [ 'confirm' ]
      }
    },
    computed: {
      ...mapState([
        'savePointCnt',
        'popupList'
      ]),
      ...mapGetters([
        'popupCnt'
      ]),
      footerBtnList () {
        let btnList = []
        this.isContinued = false

        _.forEach(this.footerBtn, (v) => {
          let btnOpt = void 0

          switch (v) {
            case 'confirm' :
              btnOpt = {
                text: this.$t('cmn.ok'),
                color: 'primary',
                type: v,
                index: 2
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'upload' :
              btnOpt = {
                text: this.$t('cmn.upLoad'),
                color: 'primary',
                type: v,
                index: 3
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'cancel' :
              btnOpt = {
                text: this.$t('cmn.cancel'),
                color: 'dark',
                type: v,
                index: 1
              }
              break
            case 'close' :
              btnOpt = {
                text: this.$t('cmn.close'),
                color: 'dark',
                type: v,
                index: 4,
                disable: this.closeDisable
              }
              break
            case 'reset' :
              btnOpt = {
                text: this.$t('cmn.reset'),
                color: 'dark',
                type: v,
                index: 5
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'continue' :
              this.isContinued = true

              btnOpt = {
                text: this.$t('cmn.continue'),
                color: 'dark',
                type: v,
                index: 0
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'continueApply' :
              this.isContinued = false

              btnOpt = {
                text: this.$t('cmn.applyContinue'),
                color: 'dark',
                type: v,
                index: 6
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'search' :
              btnOpt = {
                text: this.$t('cmn.search'),
                color: 'primary',
                type: v,
                index: 7
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'apply' :
              btnOpt = {
                text: this.$t('cmn.apply'),
                color: 'primary',
                type: v,
                index: 8
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'remove' :
              btnOpt = {
                text: this.$t('cmn.remove'),
                color: 'primary',
                type: v,
                index: 9
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'reject' :
              btnOpt = {
                text: this.$t('pa.reject'),
                color: 'primary',
                type: v,
                index: 10
                // disable: this.footerBtnDisable // TAMS
              }
              break
            case 'applyConfirm' :
              btnOpt = {
                text: this.$t('cmn.applyConfirm'),
                color: 'primary',
                type: v,
                index: 11
                // disable: this.footerBtnDisable // TAMS
              }
              break
            default:
              break
          }

          if (btnOpt) {
            btnList.push(btnOpt)
          }
        })

        return _.sortBy(btnList, ['index'])
      },
      isCheckIn () {
        return (this.$store.state.common.multirw.isCheckIn || this.ignoreCheckInState)
      }
    },
    methods: {
      ...mapMutations([
        'countSavePoint',
        'addPopup',
        'removePopup',
        'clearPopup'
      ]),
      ...mapActions([
        'setSavePoint',
        'rollbackSavePoint'
      ]),
      getAuthForce (type) {
        if (this.authForce || type === 'search' || type === 'close') {
          return true
        }

        if (this.resetAuthForce) {
          return true
        }

        return false
      },
      classStyle (type) {
        let baseClass = ['bs', 'bs-q-btn-sm']
        let confirmClass = ['bs-q-btn-popup']
        let defaultClass = ['bs-q-btn-popup-line', 'bs-q-btn-icon']
        let cancelClass = ['bs-q-btn-popup-line2', 'bs-q-btn-icon']
        let rstClass = []

        switch (type) {
          case 'confirm' :
          case 'upload' :
          case 'search' :
          case 'apply' :
          case 'reject' :
          case 'applyConfirm' :
          case 'remove' :
            rstClass = _.concat(baseClass, confirmClass)
            break
          case 'cancel' :
            rstClass = _.concat(baseClass, cancelClass)
            break
          case 'continue' :
          case 'continueApply' :
          case 'close':
          case 'reset':
            rstClass = _.concat(baseClass, defaultClass)
            break
          default :
            break
        }

        return rstClass
      },
      outlineStyle (type) {
        return type !== 'confirm' && type !== 'upload' && type !== 'search' && type !== 'apply' && type !== 'remove'
      },
      async onHide () {
        try {
          const uid = this.$parent._uid
          // this.$log('### HIDE: uid', uid)
          // this.$log('### HIDE: this.popupList.indexOf(uid)', this.popupList.indexOf(uid))
          // 이미 열린 팝업이면
          if (this.popupList.indexOf(uid) !== -1) {
            this.closeSavePoint()
            this.removePopup(uid)
            // this.$log('### 팝업창 갯수(닫힘)', this.popupCnt)
          } else {
            // this.$log('### 이미 실행됨')
          }
        } catch (e) {
          this.$log('[Error onHide]: ', e)
        }
        // 팝업창 출력 시에 html 태그 스크롤 auto 처리
        $('html').css({overflow: 'auto'})

        let content = this.$refs.layoutModalPopUp.$el.querySelector('.q-modal-layout-content')
        content.style.overflow = ''

        this.$emit('hide')
      },
      async onShow () {
        $('html').css({overflow: 'hidden'}) // 팝업창 출력 시에 html 태그 스크롤 hidden 처리

        await this.$emit('show')
      },
      onClose () {
        this.onCancel()
      },
      onConfirm () {
        if (this.confirmEvt && !this.footerBtnDisable) { // TAMS
          this.confirmEvt()
        }
      },
      onUpload () {
        if (this.uploadEvt && !this.footerBtnDisable) { // TAMS
          this.uploadEvt()
        }
      },
      async onCancel () {
        await this.releaseSavePoint()

        if (this.cancelEvt) {
          this.cancelEvt()
        }
        if (this.hideAfterCancel) {
          this.$refs.layoutModalPopUp.hide()
        }
      },
      async onContinue () {
        if (this.continueEvt && !this.footerBtnDisable) { // TAMS
          await this.continueEvt()
        }
      },
      async onSync (value) {
        if (this.syncEvt && !this.footerBtnDisable) { // TAMS
          await this.syncEvt(value)
        }
      },
      async onContinueApply () {
        if (this.continueApplyEvt && !this.footerBtnDisable) { // TAMS
          await this.continueApplyEvt()
        }
      },
      onSearch () {
        if (this.searchEvt && !this.footerBtnDisable) { // TAMS
          this.searchEvt()
        }
      },
      onReset () {
        if (this.resetEvt && !this.footerBtnDisable) { // TAMS
          this.resetEvt()
        }
      },
      onApply () {
        if (this.applyEvt && !this.footerBtnDisable) { // TAMS
          this.applyEvt()
        }
      },
      onRemove () {
        if (this.removeEvt && !this.footerBtnDisable) { // TAMS
          this.removeEvt()
        }
      },
      onApplyConfirm () {
        if (this.applyConfirmEvt && !this.footerBtnDisable) { // TAMS
          this.applyConfirmEvt()
        }
      },
      onReject () {
        if (this.rejectEvt && !this.footerBtnDisable) { // TAMS
          this.rejectEvt()
        }
      },
      onFooterEvent (btn) {
        this.clickEvtType = btn
        return this[`on${_.upperFirst(btn)}`].call()
      },
      show () {
        return new Promise((resolve, reject) => {
          try {
            const uid = this.$parent._uid
            // this.$log('### uid', uid)
            // this.$log('### this.popupList.indexOf(uid)', this.popupList.indexOf(uid))
            // 이미 열린 팝업이면
            if (this.popupList.indexOf(uid) !== -1) {
              // this.$log('## 이미 열려있음')
              return false
            }
            // this.$log('### 그다음이 실행됨???')
            this.addPopup(uid)
            // this.$log('### 팝업창 갯수(열림)', this.popupCnt)
            // 초기화
            if (this.popupCnt === 1) {
              this.countSavePoint(0)
            }

            this.makeSavePoint().then(result => {
              if (result === true) {
                this.$refs.layoutModalPopUp.show().then(() => resolve(true))
              }
            })
          } catch (e) {
            this.$log('[Error show]: ', e)
          }
        })
      },
      async hide () {
        if (this.minimized) {
          this.minimized = false
          this.$refs.layoutModalPopUp.minimize()
        }

        this.$refs.layoutModalPopUp.hide()
      },
      minimize () {
        this.minimized = !this.minimized
        this.$refs.layoutModalPopUp.minimize(this.minimized)
      },
      async makeSavePoint (force = false) {
        let result = true
        if (this.isCheckIn && !this.disableSaveRollback) {
          // this.$log('### 세이브 포인트 생성', this.savePointCnt, force)
          if (!force) {
            this.countSavePoint(this.savePointCnt + 1)
          }
          // this.$log('### 세이브 포인트 생성++', this.savePointCnt, force)
          if (this.savePointCnt === 1) {
            try {
              const res = await this.setSavePoint()
              // this.$log('### 세이브 포인트 생성 완료')
              if (res.code !== 'ok') {
                this.$alertPopUp.show(this.$t('msg.failSavePoint'))
                result = false
              }
            } catch (error) {
              this.$log('[Error onShow]: ', error)
              this.$alertPopUp.show(this.$t('msg.failSavePoint'))
              result = false
            }
          }
        }
        this.clickEvtType = void 0 // 초기화
        return result
      },
      async releaseSavePoint () {
        if (this.isCheckIn && !this.disableSaveRollback) {
          // this.$log('### 세이브 포인트 제거/생성 여부 체크', this.savePointCnt)
          if (this.savePointCnt === 1) {
            try {
              const res = await this.rollbackSavePoint()
              // this.$log('### 세이브 포인트 제거/생성')
              if (res.code !== 'ok') {
                this.$alertPopUp.show(this.$t('msg.failRollback'))
              }
            } catch (error) {
              this.$log('[Error onHide]: ', error)
              this.$alertPopUp.show(this.$t('msg.failRollback'))
            }
          }
        }
        this.clickEvtType = void 0 // 초기화
      },
      closeSavePoint () {
        if (this.isCheckIn && !this.disableSaveRollback) {
          // this.$log('### Close 세이브 포인트 해제', this.savePointCnt)
          this.countSavePoint(this.savePointCnt - 1)
          // this.$log('### Close 세이브 포인트 해제--', this.savePointCnt)
        }
      }
    },
    watch: {
      isOpen (value) {
        if (value) {
          this.continuedChecked = true
          if (this.isSynced) {
            this.syncedChecked = this.synced
          }
        }

        this.$emit('update:isOpen', value)
      },
      continuedChecked (value) {
        this.$emit('update:continued', value)
      },
      syncedChecked (value) {
        this.$emit('update:synced', value)
      }
    }
  }
</script>

<style scoped>
  .popup-scroll {
    overflow: auto;
  }
</style>
